import { useLanguage, t } from "../../../i18n";
import React from "react";
import { Card } from "react-bootstrap";
import "./StatsCard.css";
export default function StatsCard({
  title,
  value,
  icon
}) {
  useLanguage();
  const Icon = icon;
  return <Card className="bb-stats-card">
      <Card.Body>
        <div className="bb-stats-card__top">
          <div>
            <p className="bb-stats-card__title">{t(title)}</p>
            <h3 className="bb-stats-card__value">{t(value)}</h3>
          </div>

          <div className="bb-stats-card__icon bb-icon">
            <Icon />
          </div>
        </div>
      </Card.Body>
    </Card>;
}
